import * as axios from "axios"


const instance = axios.create({
  withCredentials: true,
  baseURL: 'https://social-network.samuraijs.com/api/1.0/',
  headers: {
    'API-KEY': 'c0a9584e-7a30-4113-9fb7-05af7334d856'
  }
});

export const usersAPI = {
  getUsers: (currentPage = 1, pageSize = 20) => {
    return instance.get(`users?page=${currentPage}&count=${pageSize}`)
      .then(response => response.status === 200 ? response.data : true)
  },
  follow: (userId) => instance.post(`follow/${userId}`, {}),
  unFollow: (userId) => instance.delete(`follow/${userId}`).then(response => response.data.resultCode === 0 ? response : null),
  setUsers: (userId) => profileAPI.getProfile(userId),
}


export const authAPI = {
  me: () => instance.get('auth/me').then(response => response.data),
  logIn: (object) => instance.post(`auth/login`, {
    email: object.email,
    password: object.password,
    rememberMe: object.rememberMe,
  }),
  logout: () => instance.delete('auth/login')
}

export const profileAPI = {
  getProfile: (userId) => instance.get(`profile/${userId}`).then(response => response.data),
  getStatus: (userId) => instance.get(`profile/status/${userId}`).then(response => response.data),
  updateStatus: (status) => instance.put(`profile/status`, { status: status })
}
